import "./login.component.scss"
import LOGO_MAIN from "../../assets/images/AIDA-power-by-logo.svg";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { signInWithEmailAndPassword, UserCredential } from "firebase/auth";
import { auth, db } from "../../firebase/auth.firebase";
import { addDoc, collection, doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { ProfileModel } from "../../model/profile.model";
import { useSnackbar } from "../../utility/snackbar.utility";
import CustomSnackbar from "../snackbar/snackbar.component";
import BG from "../../assets/images/auth-bg.png";

const LoginComponent = () => {
    const { snackbar, showSnackbar, hideSnackbar } = useSnackbar();
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [errors, setErrors] = useState<{ email?: string; password?: string }>({});
    const navigate = useNavigate();


    const validateForm = (): boolean => {
        const newErrors: { email?: string; password?: string } = {};

        // Email validation
        if (!email) {
            newErrors.email = "ระบุอีเมล";
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = "อีเมลไม่ถูกต้อง";
        }

        // Password validation
        if (!password) {
            newErrors.password = "ระบุรหัสผ่าน";
        } else if (password.length < 6) {
            newErrors.password = "รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (validateForm()) {
            try {
                // Sign in with email and password
                const userCredential: UserCredential = await signInWithEmailAndPassword(auth, email, password);
                // Fetch user profile from Firestore
                const userDocRef = doc(db, 'users', userCredential.user.uid);
                const userDoc = await getDoc(userDocRef);

                if (!userDoc.exists()) {
                    throw new Error('ไม่พบผู้ใช้งานในระบบ');
                }
                const userData = userDoc.data() as ProfileModel;

                // Log the successful login in Firestore
                const logRef = collection(db, "logs");
                await addDoc(logRef, {
                    timestamp: serverTimestamp(),
                    user_id: userCredential.user.uid,
                    user_email: userCredential.user.email,
                    action_type: "LOGIN"
                });
                showSnackbar("เข้าสู่ระบบสำเร็จ", "success", 3000)
                navigate("/")

            } catch (error: any) {
                showSnackbar("อีเมล หรือ รหัสผ่าน ไม่ถูกต้องกรุณาลองใหม่อีกครั้ง", "error", 3000)
            }

        }
    };

    const clickForgotPassword = () => {
        navigate("/forgot-password");
    }
    return (
        <>
            <div className="login-control">
                <div className="login-left-control">
                    <img src={BG} className="image-auth-bg" />
                </div>

                <div className="login-right-control">

                    <div className="login-right-content-control">
                        <img src={LOGO_MAIN} className="login-right-logo"></img>

                        <form onSubmit={handleSubmit} className="login-right-form-control">
                            <div>

                                <input
                                    className="login-form-input"
                                    type="email"
                                    id="email"
                                    placeholder="อีเมล"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                {errors.email && <p style={{ color: "red", fontSize: "14px" }}>{errors.email}</p>}
                            </div>

                            <div>
                                <input
                                    className="login-form-input"
                                    type="password"
                                    id="password"
                                    placeholder="รหัสผ่าน"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    style={{ width: "100%", padding: "8px", boxSizing: "border-box" }}
                                />
                                {errors.password && <p style={{ color: "red", fontSize: "14px" }}>{errors.password}</p>}
                            </div>
                            <span className="login-forgot-password" onClick={clickForgotPassword}>ลืมรหัสผ่าน</span>

                            <Button
                                type="submit"
                                className="login-submit-button"

                            >
                                เข้าสู่ระบบ
                            </Button>
                        </form>

                    </div>
                </div>
            </div>
            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                duration={snackbar.duration}
                onClose={hideSnackbar}
            />
        </>
    )

}

export default LoginComponent;